const RESPONSE_SUCCESS = 0

module.exports = {
	RESPONSE_SUCCESS,
}
